import apiHeader from '@/helpers/apiHeader';

const flagUnflagFormService = {
    save(id, params) {
        return apiHeader.post(`request-pool/flag-unflag/save/${id}`, params);
    },
};

export default flagUnflagFormService;
